var map = {
	"./international.de-CH.json": 1545,
	"./international.de-DE.json": 1546,
	"./international.en-CA.json": 1547,
	"./international.en-GB.json": 1548,
	"./international.en-IN.json": 1549,
	"./international.en-ME.json": 1550,
	"./international.en-US.json": 1551,
	"./international.es-EM.json": 1552,
	"./international.es-ES.json": 1553,
	"./international.fr-BE.json": 1554,
	"./international.fr-CA.json": 1555,
	"./international.fr-CH.json": 1556,
	"./international.nl-BE.json": 1557,
	"./international.nl-NL.json": 1558,
	"./international.pl-PL.json": 1559,
	"./international.pt-BR.json": 1560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1544;